import React from 'react'
import PropTypes from 'prop-types'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import UploadInput from '../input/upload'
import { Button } from 'react-bootstrap'

const UploadingEditForm = observer(({ state }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(defaultConst.ENTNAMES.PPROLLS_UPLOAD, 'w')
  const hasID = record.has('id')
  const { stageOneRestricted, stageTwoRestricted } = state.timeRestriction.checkSubentity(state, state)
  const dateRestriction = state.timeRestriction[state.cv.entityname]
  state.skipWarning = true

  return (
    <div className='row'>
      <div className='col-xs-12 col-lg-8'>
        <TextInput disabled type='text' label={state.__('state')} record={record}
          value={record.has('state') ? record.get('state') : state.__('new')} />
        {(!record.has('state') || (record.has('state') && record.get('state') !== 'encoded')) &&
          <span>
            <Button bsStyle='success'
              onClick={() => record.set('state', 'encoding') && state.encodeVideo(record) && state.onReturn2list()}
              disabled={!(record.has('state') && record.get('state') === 'uploaded') || disabled}>
              <span className='glyphicon glyphicon-compressed' />&nbsp; {state.__('Encode')}
            </Button><br />&nbsp;
          </span>}
        <RegionsInput store={state} label={state.__('regions')} attr={'regions'} disabled={stageOneRestricted || stageTwoRestricted || disabled}
          record={record} onChange={updateField} errors={errors}
          optionsrecord={state.options} optionsattr={'Countries'} />
        <SelectInput label={state.__('lang')}
          attr={'lang'} record={record}
          onChange={updateField} optionsrecord={state.options}
          optionsattr={'Languages'}
          disabled={stageOneRestricted || hasID || disabled}
          labelattr='text' valueattr='value' errors={errors} />
        <DateInput label={state.__('valid from')} attr={'valid_from'}
          disabled={stageOneRestricted || disabled || (hasID && record.get('valid_from') && moment(record.get('valid_from')).isSame(moment(), 'day'))}
          minDate={dateRestriction.valid_from.minDate}
          record={record} onChange={updateField} errors={errors} />
        <DateInput label={state.__('valid to')} attr={'valid_to'} disabled={stageTwoRestricted || disabled}
          record={record} onChange={updateField} errors={errors}
          minDate={dateRestriction.valid_to.minDateToday &&
          (!hasID || !record.get('id') || (record.has('valid_from') && record.get('valid_from') &&
          moment(record.get('valid_from')).isSameOrAfter(dateRestriction.valid_to.minDateToday, 'day')))
            ? dateRestriction.valid_to.minDateToday
            : dateRestriction.valid_to.minDate}
        />
        {state.showFileBrowse(record) && !record.has('id')
          ? <UploadInput record={record} attr='file' disabled={stageOneRestricted || disabled}
            label={state.__('file')} onChange={updateField} errors={errors} />
          : <React.Fragment>
            <TextInput disabled
              type='text' label={state.__('Original filename')} attr={'original_filename'}
              record={record} errors={errors} />
            <TextInput disabled
              type='text' label={state.__('S3 filename')} attr={'s3_filename'}
              record={record} errors={errors} />
          </React.Fragment>
        }
      </div>
    </div>
  )
})

UploadingEditForm.propTypes = {
  state: PropTypes.object.isRequired
}

const UploadingEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.PPROLLS_UPLOAD)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView
      store={store.cv}
      onReturn2list={store.onReturn2list.bind(store)}
      onSaveUpload={store.saveUpload.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.PPROLLS_UPLOAD, 'w')} >
      <UploadingEditForm state={store} selectionState={observable.box([])} />
    </EditView>
  )
}
export default UploadingEditView
